import React, { forwardRef, useEffect } from 'react';

import Icon from 'components/shared/Icon';
import ArrowUp from 'components/shared/Icon/icons/ArrowUp';

import Dropdown from '../Dropdown';
import s from './index.module.css';

const Popup = forwardRef(({ top, content, onRender }, ref) => {
  useEffect(() => {
    // @todo - refactor this
    new Promise((res) => setTimeout(res, 100)).then(onRender);
  }, [onRender]);

  return (
    <div style={{ position: 'absolute', top }} ref={ref}>
      <div className={s.wrapper}>
        <Icon component={ArrowUp} className={s.icon} />
        <Dropdown style={{ width: '19.7rem' }}>{content}</Dropdown>
      </div>
    </div>
  );
});

export default Popup;
